---
title: Налаштування електронної пошти та поштової скриньки
parent: Документація
parentHref: /docs
---

# Налаштування Вашої поштової скриньки

Ваш тарифний план TOBY включає професійну адресу електронної пошти, що відповідає Вашому домену (наприклад, info@your-domain.de), з **поштовою скринькою на 15 ГБ (Maxi-Postfach)**, а також необмежену кількість адрес для пересилання пошти. Потрібно більше поштових скриньок або додаткове сховище? Ви можете додати ще одну поштову скриньку на 15 ГБ у будь-який час — див. [прайс-лист](/uk/pricing).

## 1. Створіть поштову скриньку в TOBY

1. Відкрийте **Налаштування → Електронна пошта** в TOBY.
2. Виберіть бажану адресу (наприклад, info@, hello@ або contact@) і створіть поштову скриньку.
3. **Скопіюйте Ваш пароль:** TOBY показує згенерований пароль до поштової скриньки лише один раз одразу після створення. Скопіюйте або збережіть його перед закриттям вікна. (Якщо Ви коли-небудь втратите його, Ви можете згенерувати новий пароль одним кліком у розділі **Налаштування → Електронна пошта** — Ваші існуючі листи залишаться в безпеці.)

## 2. Читайте та надсилайте електронну пошту у Вашому браузері (Webmail)

Ви можете відкрити Вашу поштову скриньку з будь-якого комп'ютера або телефону через браузер без встановлення додатків:

- **Адреса вебпошти:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Ім'я користувача:** Ваша повна адреса електронної пошти (наприклад, info@your-domain.de)
- **Пароль:** пароль до поштової скриньки з розділу **Налаштування → Електронна пошта**

## 3. Підключіть Ваш телефон або комп'ютер (IMAP і SMTP)

Щоб читати та надсилати листи в **Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook** або **Thunderbird**, додайте новий обліковий запис **IMAP** у Вашому поштовому додатку та введіть такі налаштування сервера:

| Налаштування | Значення |
| --- | --- |
| **Тип облікового запису** | IMAP |
| **Адреса електронної пошти / Ім'я користувача** | Ваша повна адреса електронної пошти (наприклад, info@your-domain.de) |
| **Пароль** | Ваш пароль до поштової скриньки з розділу Налаштування → Електронна пошта |
| **Сервер вхідної пошти (IMAP)** | mail.tobysite.com |
| **Порт вхідної пошти** | 993 (SSL/TLS) |
| **Сервер вихідної пошти (SMTP)** | mail.tobysite.com |
| **Порт вихідної пошти** | 465 (SSL/TLS) або 587 (STARTTLS) |

> **Важливо:** Переконайтеся, що Ви ввели **повну адресу електронної пошти** (включно з @your-domain.de) як ім'я користувача для **обох** серверів — вхідної пошти (IMAP) і вихідної пошти (SMTP).

### Покрокова інструкція для iPhone та iPad (iOS Mail)

1. Відкрийте додаток **Налаштування** на iPhone → **Програми** → **Пошта** → **Облікові записи пошти** → **Додати обліковий запис** → **Інше** → **Додати обліковий запис пошти**.
2. Введіть Ваше ім'я, Вашу повну адресу електронної пошти, Ваш пароль до поштової скриньки та короткий опис. Натисніть **Далі**.
3. Залиште вибраним **IMAP** у верхній частині.
4. У розділах **Сервер вхідної пошти** та **Сервер вихідної пошти** введіть mail.tobysite.com як ім'я хоста, Вашу повну адресу електронної пошти як ім'я користувача та Ваш пароль до поштової скриньки.
5. Натисніть **Далі**, а потім **Зберегти**.

### Покрокова інструкція для Android (додаток Gmail)

1. Відкрийте додаток **Gmail**, натисніть Ваше фото профілю у верхньому правому куті → **Додати інший обліковий запис** → **Інше**.
2. Введіть Вашу повну адресу електронної пошти та натисніть **Налаштування вручну** → **Особиста (IMAP)**, потім введіть Ваш пароль.
3. Для **сервера вхідної пошти** встановіть сервер mail.tobysite.com, порт 993 і тип захисту SSL/TLS.
4. Для **сервера вихідної пошти SMTP** встановіть сервер mail.tobysite.com, порт 465 (SSL/TLS) і переконайтеся, що ввімкнено **Потрібен вхід** з Вашою повною адресою електронної пошти.
5. Натисніть **Далі**, щоб завершити.

Далі: [Розсилка та оголошення](/uk/docs/newsletter).
